<!-- Table View -->
@if (fileContainer !== undefined && layout() === "table") {
	<article class="files">
		@if ((!fileContainer.files || !fileContainer.files.length) && !isUploadAllowed() && !showStartOptions()) {
			<p class="empty" translate="{{ translateNone() }}"></p>
		}
		@if (fileContainer.files && fileContainer.files.length) {
			<table class="table dense">
				<colgroup>
					<col class="name-col" />
					<col class="small-icon-col" />
					<col />
					<col />
					<col />
					<col class="action-col" />
				</colgroup>
				<thead>
					<tr>
						<th translate="files.filetable.columnheader.name"></th>
						<th class="icon-cell"><i class="ico ico-lock"></i></th>
						<th translate="files.filetable.columnheader.author"></th>
						<th translate="files.filetable.columnheader.lastChange"></th>
						<th translate="files.filetable.columnheader.state"></th>
						@if (someChangeMarker(fileContainer.files)) {
							<th class="change-marker" translate="files.filetable.columnheader.modification"></th>
						}
						<th class="warning"></th>
						<th class="action"></th>
					</tr>
				</thead>
				<tbody>
					@for (file of this.fileContainer.files; track file) {
						<tr [ngClass]="{ disabled: isDisabled(file), 'new-item': file.recentlyAdded, 'add-item': isRenamed(file) }">
							<td>
								@if (isRenamed(file)) {
									<form #form="ngForm" class="form-add-item icon-name" novalidate>
										<ng-container *ngTemplateOutlet="fileRenameInput; context: { $implicit: file }"></ng-container>
									</form>
								}
								<ng-container *ngTemplateOutlet="fileTableLink; context: { $implicit: file }"></ng-container>
							</td>
							<td [ngClass]="{ fixed: file.frozenVersion }">
								<ng-container *ngTemplateOutlet="fileStatusIcons; context: { $implicit: file }"></ng-container>
							</td>
							<td>
								@if (!!file.user && !!file.user.fullname) {
									<span>{{ file.user!.fullname }}</span>
								}
							</td>
							<td>
								@if (!!file.date) {
									<span>{{ file.date }}</span>
								}
							</td>
							<td>
								<div [ngClass]="getFileStateClasses(file)">
									<span class="state-icon"></span>
									<ng-container *ngTemplateOutlet="fileStateLabel; context: { $implicit: file }"></ng-container>
								</div>
							</td>
							@if (someChangeMarker(fileContainer.files)) {
								<td class="change-marker">
									<ng-container *ngTemplateOutlet="changeMarker; context: { $implicit: file }"></ng-container>
								</td>
							}
							<td class="warning">
								@if (showWarning(file)) {
									<button
										[attr.title]="'error' | translate"
										[attr.aria-label]="'error' | translate"
										class="warning-button"
										(click)="onError(file)"
									>
										<i class="ico ico-warning warning-color"></i>
									</button>
								}
							</td>
							<td class="action progress-img">
								<ng-container *ngTemplateOutlet="fileMenu; context: { $implicit: file }"></ng-container>
								<div>
									@if (isShowProgressBar(file)) {
										<stages-spin size="sm"></stages-spin>
									}
								</div>
							</td>
						</tr>
					}
				</tbody>
			</table>
		}
		<ng-container *ngTemplateOutlet="fileWidgetFooter"></ng-container>
	</article>
}

<!-- List View -->
@if (fileContainer !== undefined && layout() === "list") {
	<article class="files">
		@if ((!fileContainer.files || !fileContainer.files.length) && !isUploadAllowed() && !showStartOptions()) {
			<p class="empty" translate="{{ translateNone() }}"></p>
		}
		@if (fileContainer.files && fileContainer.files.length) {
			<ul class="list dense">
				@for (file of fileContainer.files; track file) {
					<li class="list-item" [ngClass]="{ disabled: isDisabled(file), 'new-item': file.recentlyAdded }">
						@if (isRenamed(file)) {
							<form #form="ngForm" class="form-add-item label" novalidate>
								<ng-container *ngTemplateOutlet="fileRenameInput; context: { $implicit: file }"></ng-container>
							</form>
						}
						<ng-container *ngTemplateOutlet="fileListLink; context: { $implicit: file }"></ng-container>
						@if (showWarning(file)) {
							<div class="action">
								<button
									[attr.title]="'error' | translate"
									[attr.aria-label]="'error' | translate"
									(click)="onError(file)"
								>
									<i class="ico ico-warning warning-color"></i>
								</button>
							</div>
						}
						@if (isShowProgressBar(file)) {
							<div class="action progress-img">
								<stages-spin size="sm"></stages-spin>
							</div>
						}
						<ng-container *ngTemplateOutlet="fileMenu; context: { $implicit: file }"></ng-container>
					</li>
				}
			</ul>
		}
		<ng-container *ngTemplateOutlet="fileWidgetFooter"></ng-container>
	</article>
}

<ng-template #fileRenameInput let-file>
	<i [ngClass]="getIconClasses(file)"></i>
	<div style="width: 100%">
		<span class="h4">
			<input
				#nameControl="ngModel"
				id="name"
				name="name"
				type="text"
				[stagesMaxLength]="255"
				required
				[(ngModel)]="renameName"
				(stagesKeyUp)="onKeyUp($event, file)"
				(blur)="onRenameBlur()"
				stagesAutofocus
			/>
		</span>
		<div class="info">
			@if (nameControl.errors && (nameControl.dirty || nameControl.touched)) {
				<div class="errors">
					@if (nameControl?.errors?.required) {
						<div class="error" role="alert" translate="input.required"></div>
					}
					@if (nameControl?.errors?.max) {
						<div class="error" role="alert" translate="input.maxLength" [translateParams]="{ length: 255 }"></div>
					}
				</div>
			}
			<div class="max-length">{{ nameControl.value?.length || 0 }}/255</div>
		</div>
	</div>
</ng-template>

<ng-template #fileTableLink let-file>
	@if (isDisabled(file) && !isRenamed(file)) {
		<div (contextmenu)="onRightClick($event, file)" class="icon-name">
			<ng-container *ngTemplateOutlet="fileTableLinkContent; context: { $implicit: file }"></ng-container>
		</div>
	}
	@if (!isDisabled(file) && !isRenamed(file) && !isURL(file)) {
		<a
			draggable="true"
			(click)="onLeftClick(file)"
			(contextmenu)="onRightClick($event, file)"
			class="icon-name clickable"
			(dragstart)="onDragStart($event, file)"
		>
			<ng-container *ngTemplateOutlet="fileTableLinkContent; context: { $implicit: file }"></ng-container>
		</a>
	}
	@if (!isDisabled(file) && !isRenamed(file) && isURL(file)) {
		<a
			draggable="true"
			[attr.target]="getTarget(file)"
			[attr.rel]="getTargetRelation(file)"
			[attr.href]="getUrlWithoutUnsafeForNonHttp(file)"
			(contextmenu)="onRightClick($event, file)"
			class="icon-name clickable"
			(dragstart)="onDragStart($event, file)"
		>
			<ng-container *ngTemplateOutlet="fileTableLinkContent; context: { $implicit: file }"></ng-container>
		</a>
	}
</ng-template>

<ng-template #fileTableLinkContent let-file>
	<i [ngClass]="getIconClasses(file)"></i>
	<span class="h4" title="{{ file.url }}">{{ file.name }}</span>
</ng-template>

<ng-template #fileListLink let-file>
	@if (isDisabled(file) && !isRenamed(file)) {
		<div class="label" (contextmenu)="onRightClick($event, file)">
			<ng-container *ngTemplateOutlet="fileListLinkContent; context: { $implicit: file }"></ng-container>
		</div>
	}
	@if (!isDisabled(file) && !isRenamed(file) && !isURL(file)) {
		<a
			class="label clickable"
			draggable="true"
			(click)="onLeftClick(file)"
			(contextmenu)="onRightClick($event, file)"
			(draggable)="(true)"
			(dragstart)="onDragStart($event, file)"
		>
			<ng-container *ngTemplateOutlet="fileListLinkContent; context: { $implicit: file }"></ng-container>
		</a>
	}
	@if (!isDisabled(file) && !isRenamed(file) && isURL(file)) {
		<a
			class="label clickable"
			draggable="true"
			[attr.target]="getTarget(file)"
			[attr.rel]="getTargetRelation(file)"
			[attr.href]="getUrlWithoutUnsafeForNonHttp(file)"
			(contextmenu)="onRightClick($event, file)"
			(draggable)="(true)"
			(dragstart)="onDragStart($event, file)"
		>
			<ng-container *ngTemplateOutlet="fileListLinkContent; context: { $implicit: file }"></ng-container>
		</a>
	}
</ng-template>

<ng-template #fileListLinkContent let-file>
	<i [ngClass]="getIconClasses(file)"></i>
	<div class="text">
		<span class="h4">{{ file.name }}</span>
		@if (isUserAndDateKnown(file)) {
			<p>
				<ng-container *ngTemplateOutlet="fileStatusIcons; context: { $implicit: file }"></ng-container>
				{{ file.user?.fullname }} - {{ file.date }}
			</p>
		}
		@if (isOnlyUserKnown(file)) {
			<p>
				<ng-container *ngTemplateOutlet="fileStatusIcons; context: { $implicit: file }"></ng-container>
				{{ file.user?.fullname }}
			</p>
		}
		<p [ngClass]="getFileStateClasses(file)">
			<ng-container *ngTemplateOutlet="fileStateLabel; context: { $implicit: file }"></ng-container>
		</p>
		@if (file.changeMarker) {
			<p>
				<ng-container *ngTemplateOutlet="changeMarker; context: { $implicit: file }"></ng-container>
			</p>
		}
	</div>
</ng-template>

<ng-template #fileStateLabel let-file>
	<span class="state-name">{{ file.stateMessageKey ? (file.stateMessageKey | translate) : file.stateIdent }}</span>
</ng-template>

<ng-template #fileStatusIcons let-file>
	@if (file.locked && !file.frozenVersion) {
		<i class="ico ico-lock"></i>
	}
	@if (file.frozenVersion) {
		<i class="ico ico-pin"></i>
	}
</ng-template>

<ng-template #fileMenu let-file>
	@if (!isShowProgressBar(file)) {
		<stages-menu
			menuId="fam{{ file.id }}"
			[noCollapse]="true"
			class="action"
			iconClasses="ico ico-more-vertical"
			openTo="left"
			[items]="menuItems"
			[menuTitle]="$any(!!file.frozenVersion ? fixedVersionMenuTitle.title : null)"
			[subtitle]="$any(!!file.frozenVersion ? fixedVersionMenuTitle.subtitle : null)"
			titleIconClass="ico-pin"
			[titleParams]="[file.frozenVersion]"
			[context]="file"
		/>
	}
</ng-template>

<ng-template #fileWidgetFooter>
	@if (isUploadAllowed()) {
		<stages-upload
			uploadIcon="ico ico-file"
			[uploadCompletedCallback]="uploadCompletedCallback"
			[filesDroppedCallback]="filesDroppedCallback"
			[uploadUrl]="uploadUrl"
			[multiple]="true"
		/>
	}
	@if (showStartOptions() && !(!!fileContainer.files && fileContainer.files.length)) {
		<stages-files-start [startOptions]="$any(startOptions)" translate-none="files.start.options.none" />
	}
</ng-template>

<ng-template #changeMarker let-file>
	@if (file.changeMarker) {
		@if (file.changeMarker.added) {
			<span class="badge added-badge" translate="process.compare.added"></span>
		}
		@if (file.changeMarker.deleted) {
			<span class="badge deleted-badge" translate="process.compare.deleted"></span>
		}
		@if (file.changeMarker.changed) {
			<span class="badge changed-badge" translate="process.compare.changed"></span>
		}
	}
</ng-template>
